import Grid, { Grid2Props } from "@mui/material/Unstable_Grid2"
import { FC, memo } from "react"

export const GridRow: FC<Grid2Props> = memo((props) => (
  <Grid {...props}>{props?.children}</Grid>
))

GridRow.displayName = "GridRow"
